/* @jsx UiSchema.createElement */

import { UiSchema } from '@rushplay/forms'

export const uiSchema = (
  <UiSchema.Box
    sx={{
      display: 'grid',
      gridGap: 1,
    }}
  >
    <UiSchema.Control scope="#/properties/email" />
    <UiSchema.Control scope="#/properties/password" />
  </UiSchema.Box>
)
